import { render, staticRenderFns } from "./index-zfcg.vue?vue&type=template&id=dd1da476&scoped=true&"
import script from "./index-zfcg.vue?vue&type=script&lang=js&"
export * from "./index-zfcg.vue?vue&type=script&lang=js&"
import style0 from "./index-zfcg.vue?vue&type=style&index=0&id=dd1da476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1da476",
  null
  
)

export default component.exports